<script setup lang="ts">
import { renderRichContent } from '~/utils/sanitize'

const props = defineProps<{ content?: string | null }>()
const rendered = computed(() => renderRichContent(props.content || ''))
</script>

<template>
  <div class="rich-content prose dark:prose-invert max-w-none" v-html="rendered" />
</template>

<style scoped>
.rich-content :deep(.content-video) {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 0.75rem;
  background: #000;
}
.rich-content :deep(.content-video iframe) {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.rich-content :deep(.content-video--tiktok) {
  max-width: 24rem;
  margin-inline: auto;
  aspect-ratio: 9 / 16;
}
.rich-content :deep(img) {
  max-width: 100%;
  height: auto;
}
</style>
